export default {
  placeholder: 'Suche Restaurant...',
};
